import React, { useState } from "react"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function DirectUrlModal(props) {

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="custom-modal-border"
      centered
    >
      <Modal.Header
        style={{
          background: "#f4f6fa",
          borderBottom: "2px solid #0173d4",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          padding: "18px 24px"
        }}>
        <Modal.Title id="contained-modal-title-vcenter"
          style={{
            color: "#0173d4",
            textAlign: "center",
            fontSize: "22px",
            fontWeight: "bold",
            width: "100%",
            letterSpacing: "1px"
          }}>
          Direct PDF/Gendoc Links
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          background: "#fff",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
          padding: "28px 32px 18px 32px"
        }}>
        <div
          style={{
            fontSize: "17px",
            marginTop: "0px",
            color: "#0173d4",
            fontWeight: "600",
            textAlign: "center",
            letterSpacing: "0.5px",
            marginBottom: "18px",
            borderBottom: "1px solid #e0e0e0",
            paddingBottom: "10px"
          }}
        >
          PDF or GenDoc for a part can be downloaded directly using the following links
        </div>
        <div style={{ textAlign: "center", marginBottom: "18px" }}>
        </div>
        <div
          style={{
            fontSize: "15px",
            marginTop: "24px",
            color: "#222",
            background: "#f4f6fa",
            borderRadius: "6px",
            padding: "12px 16px",
            textAlign: "center",
            marginBottom: "10px",
            fontFamily: "var(--app-font-family)"
          }}
        >
          <span style={{ color: "#0173d4", fontWeight: "bold" }}>PDF: </span>
          {`${process.env.REACT_APP_DOMAIN_NAME}/PDF/download/pdf/<GCAS>`}
        </div>
        <div
          style={{
            fontSize: "15px",
            marginTop: "10px",
            color: "#222",
            background: "#f4f6fa",
            borderRadius: "6px",
            padding: "12px 16px",
            textAlign: "center",
            fontFamily: "var(--app-font-family)"
          }}
        >
          <span style={{ color: "#0173d4", fontWeight: "bold" }}>GenDoc: </span>
          {`${process.env.REACT_APP_DOMAIN_NAME}/PDF/download/gendoc/<GCAS>`}
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          background: "#f4f6fa",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
          borderTop: "1px solid #e0e0e0"
        }}
      >
        <Button
          onClick={props.onHide}
          style={{
            background: "#0173d4",
            border: "none",
            fontWeight: "bold",
            borderRadius: "4px",
            padding: "8px 28px"
          }}
        > Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DirectUrlModal